import { Form } from "antd";
import React, { useContext, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useChange, useFormateMsg, useUtils } from "../hooks";
import { appReducersActions } from "../store/reducers/app";
import { FormContext } from "../context/form";
export const TitleBar = ({ info }) => {
  const { form } = useContext(FormContext);
  const { isSame } = useUtils();
  const dispatch = useDispatch();
  const { formatMsg } = useFormateMsg();
  const { handler } = useChange(form);
  const handlePreview = (url) => {
    dispatch(appReducersActions.setPreviewModal({ show: true, url }));
  };
  const choiceText = useMemo(() => {
    const { maxChoice, minChoice } = info;
    if (maxChoice && minChoice) {
      return formatMsg("questionTitle.choiceTxt-between")
        .replace("$1", minChoice)
        .replace("$2", maxChoice);
    } else if (minChoice) {
      return formatMsg("questionTitle.choiceTxt-less").replace("$1", minChoice);
    } else if (maxChoice) {
      return formatMsg("questionTitle.choiceTxt-more").replace("$1", maxChoice);
    } else return "";
  }, [formatMsg, info]);
  const handleClick = (e) => {
    let el = e.target;
    if (el.nodeName.toLocaleLowerCase() == "img") {
      let src = el.src;
      if (el.naturalWidth > 50 || el.naturalHeight > 50) {
        handlePreview(src);
      }
    }
  };

  const shouldUpdate = (prev, cur) => {
    return (
      prev.suveryInfo != cur.suveryInfo || prev.postAnswer != cur.postAnswer
    );
  };

  return (
    <Form.Item noStyle shouldUpdate={shouldUpdate}>
      {({ getFieldValue, setFieldsValue }) => {
        let suveryInfo = getFieldValue("suveryInfo") || {};
        // 非必填且有答案时显示清除选择按钮
        let showClear = !info.required;
        if (showClear === true) {
          let postAnswer = getFieldValue("postAnswer") || [];
          if (!postAnswer[info.position]) showClear = false;
        }
        const clearAnswer = () => {
          let postAnswer = [];
          postAnswer[info.position] = "$=>clear";
          handler({ postAnswer });
        };
        return (
          <React.Fragment>
            <div className="title-bar">
              {info.required && <span className="required-label">*</span>}
              <div className="title">
                {suveryInfo.showQuesNum && (
                  <span className="position">{info.quesNum}.</span>
                )}
                <span
                  dangerouslySetInnerHTML={{ __html: info?.translation?.title }}
                  onClick={handleClick}
                ></span>
                {choiceText==="" && (isSame(info.type, "9") || isSame(info.type, "2")) && (
                  <span className="question-type">
                    [
                    {formatMsg(
                      `questionTitle.type.${
                        isSame(info.type, "2") ? "checkbox" : "sort"
                      }`
                    )}
                    ]
                  </span>
                )}
                {choiceText !== "" && (
                  <span className="choice-text">[{choiceText}]</span>
                )}
                {showClear && !info.required && (
                  <span className="clear-text" onClick={clearAnswer}>
                    [{formatMsg("questionTitle.clearTxt")}]
                  </span>
                )}
              </div>
            </div>
            {info?.translation?.titleTip && (
              <div className="description">{info.translation.titleTip}</div>
            )}
          </React.Fragment>
        );
      }}
    </Form.Item>
  );
};

export const OptList = ({ list, type, onCheck, value = [], onChange }) => {
  const { isSame } = useUtils();
  const dispatch = useDispatch();
  const { isMobile } = useSelector((state) => state.app);
  const handlePreview = (url) => {
    dispatch(appReducersActions.setPreviewModal({ show: true, url }));
  };
  const handleIpt = (item, targetVal) => {
    let _value = [...value];
    let index = _value.findIndex((o) => isSame(o.position, item.position));
    let _item = value[index];
    _value.splice(index, 1, { ..._item, answerText: targetVal });
    onChange(_value);
  };

  return list.map((item) => {
    let isCheck = false;
    let index = value.findIndex((o) => isSame(o.position, item.position));
    let showIpt = false;
    let iptVal = "";
    if (index >= 0) {
      let _item = value[index];
      isCheck = _item.checked;
      showIpt = isCheck && isSame(item.type, "1");
      iptVal = _item.answerText || "";
    }
    let iptSize = iptVal?.length || 0;
    iptSize = iptSize < 15 ? 15 : iptSize;
    return (
      <div
        key={item.position}
        className={`list-item ${item.picUrl ? "has-img" : ""}`}
        onClick={() => onCheck(item)}
      >
        <div className="icon-wrap">
          <div className={`icon ${type} ${isCheck ? "check" : ""}`}>
            {type === "sort" && isCheck && (
              <div className="position">{index + 1}</div>
            )}
          </div>
        </div>
        <div className="content-box">
          {item.picUrl && (
            <div className="img-box">
              <img src={item.picUrl} alt="img"></img>
              <i
                className="iconfont icon-zoom"
                onClick={(e) => {
                  e.stopPropagation();
                  handlePreview(item.picUrl);
                }}
              ></i>
            </div>
          )}
          <div className="content">
            <div className="text">{item.text}</div>
            {showIpt && (
              <div className="ipt-wrap">
                {isMobile && item.required && (
                  <span className="required-label">*</span>
                )}
                <input
                  onClick={(e) => e.stopPropagation()}
                  className="ipt"
                  value={iptVal}
                  size={iptSize}
                  onChange={(e) => handleIpt(item, e.target.value)}
                ></input>
                {!isMobile && item.required && (
                  <span className="right-required">*</span>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  });
};
